import {
  getFirestore,
  onSnapshot,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  getDocs,
  collection,
  where,
  query,
  serverTimestamp,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { TYPES } from "./role.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------------------- Snapshot --------------------------
const ownerSub = [];
export const snapOwner = (callback) => (dispatch) => {
  getIsOwnerSuccess(dispatch, null);
  getOwnerSuccess(dispatch, null);
  const cRef = collection(firestore, REF.OWNER);
  const uid = auth?.currentUser?.uid;
  const dRef = doc(cRef, uid);
  // snapshot
  const unSub = onSnapshot(dRef, (doc) => {
    const data = doc.data();
    // console.log({ data, uid });
    if (data) {
      getIsOwnerSuccess(dispatch, true);
      getOwnerSuccess(dispatch, data);
      if (callback) {
        callback(data);
      }
    } else {
      getIsOwnerSuccess(dispatch, false);
    }
  });
  ownerSub.push(unSub);
};

export const unSnapOwner = () => (dispatch) => {
  ownerSub.forEach((subscriber) => {
    subscriber();
  });
  ownerSub.length = 0;
};

// -------------------------- Add Owner if not exist --------------------------

export const addOwnerInfo =
  ({ user }) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.OWNER);
    const uid = auth?.currentUser?.uid;
    const dRef = doc(cRef, uid);
    getDoc(dRef).then((doc) => {
      const data = doc.data();
      if (!data) {
        const info = {
          ...user,
          id: uid,
          createAt: serverTimestamp(),
          active: true,
        };
        setDoc(dRef, info, { merge: true });
      }
    });
  };

// -------------------------- Update Owner Info --------------------------
export const updateOwnerInfo =
  ({ update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.OWNER);
    const uid = auth?.currentUser?.uid;
    const dRef = doc(cRef, uid);
    const ird = update?.ird;
    console.log({ ird });
    // check Duplicate
    // const cRef0 = collection(firestore, REF.USER);
    // const c0 = where("ird", "==", ird);
    // const qRef = query(cRef0, c0);
    // getDocs(qRef).then((snapshot) => {
    //   if (snapshot?.docs?.length === 0) {
    updateDoc(dRef, update)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error?.message,
          });
        }
      });
    //   } else {
    //     if (callback) {
    //       callback({
    //         status: 500,
    //         data: "Duplicate IRD",
    //       });
    //     }
    //   }
    // });
  };

// -------------------------- Dispatch --------------------------
const getOwnerSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_OWNER_INFO_SUCCESS,
    payload: data,
  });
};

const getIsOwnerSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_IS_OWNER_SUCCESS,
    payload: data,
  });
};
